/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateAssociatedCompanyDocumentStatusResponseViewModel } from "../types/UpdateAssociatedCompanyDocumentStatusResponseViewModel.ts";

export const updateAssociatedCompanyDocumentStatusResponseViewModelSchema =
  z.object({
    documentationStatus: z
      .number()
      .int()
      .describe(
        "Status geral recalculado da documentação da conveniada; nulo quando os documentos obrigatórios têm status mistos. Não é persistido neste endpoint. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
      )
      .nullish(),
    documentationStatusText: z
      .string()
      .describe("Descrição do status geral recalculado (pt-BR). Opcional.")
      .nullish(),
  }) as unknown as ToZod<UpdateAssociatedCompanyDocumentStatusResponseViewModel>;
